export const DELETE_TRANSACTION_PRICING_OFFER = gql`
    mutation deleteTransactionPricingOffer($id: Int!) {
        deleteTransactionPricingOffer(id: $id)
    }
`;
